<template>
  <div class="allBox">
    <div class="title">
      <strong @click="$router.go(-1)" style="cursor: pointer"
        ><i class="el-icon-back"></i
      ></strong>
      <span @click="test">创建第N份优惠活动</span>
    </div>
    <div class="href">
      <div class="item"><span @click="go(133)">活动基础信息</span></div>
      <div class="item"><span @click="go(358)">活动日期</span></div>
      <div class="item"><span @click="go(884)">活动规则</span></div>
    </div>
    <div class="scroll">
      <div class="mainBox">
        <div class="card">
          <div class="cardBody">
            <div class="left">
              <img src="../../assets/images/active/download.svg" alt="" />
            </div>
            <div class="right">
              <div class="top">第N份优惠活动介绍</div>
              <div class="bottom">
                提升客单的优惠活动,常用于情侣消费、朋友消费，例：饮品第二杯半价。活动菜品的【做法加价】参与优惠，【加料】和【餐盒】均不参与优惠。
              </div>
            </div>
          </div>
        </div>
        <h3 class="textTitle">活动基础信息</h3>
        <el-form label-width="112px">
          <el-form-item label="活动名称" required>
            <el-input
              style="width: 415px"
              placeholder="请输入活动名称"
              v-model="addForm.planName"
            ></el-input>
          </el-form-item>
          <el-form-item label="展示名称">
            <el-input style="width: 415px" v-model="addForm.showName" placeholder="请输入"></el-input>
            <div class="labelMore">
              自定义小程序商家详情页活动展示名称
              <span style="color: #c62d2d">（该功能目前不支持小程序2.0）</span>
              <span class="f6" style="margin-left: 16px">查看示例</span>
            </div>
          </el-form-item>
          <el-form-item label="活动渠道" required>
            <el-checkbox-group v-model="checkedList" @change="getActiveRules">
              <el-checkbox label="1" disabled>收银机</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <h3 class="textTitle">活动日期</h3>
          <el-form-item label="活动日期" required>
            <el-radio-group v-model="addForm.planDateType">
              <el-radio :label="1">永久有效</el-radio>
              <el-radio :label="2">自定义日期</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="addForm.planDateType == 2" label="自定义日期" required>
            <el-date-picker
              value-format="timestamp"
              v-model="dateRange"
              @change="getDIYDate"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="f6" @click="showMoreTime">
              {{ moreTimeText }}更多设置
              <i
                style="
                  transform: translateY(2px);
                  font-weight: 600;
                  font-size: 16px;
                "
                class="el-icon-arrow-down"
                v-if="isShowMoreTime == false"
              ></i>
              <i
                style="
                  transform: translateY(2px);
                  font-weight: 600;
                  font-size: 16px;
                "
                class="el-icon-arrow-up"
                v-if="isShowMoreTime == true"
              ></i>
            </div>
          </el-form-item>
          <el-form-item label="不可用日期" v-if="isShowMoreTime == true">
            <div
              class="item"
              v-for="(ite, index) in unuseDateList"
              style="margin-bottom: 6px"
              :key="index"
            >
              <el-date-picker
                v-model="ite.time"
                type="daterange"
                @change="getUnableDate(index)"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                style="aspect-ratio: 1/1"
                icon="el-icon-minus"
                circle
                @click="reduceUnuseDate(index)"
              ></el-button>
            </div>
            <span class="f6" @click="addUnuseDate">添加一个日期段</span>
            <div style="color: #666">该促销活动在指定日期不生效</div>
          </el-form-item>
          <el-form-item label="活动星期" required class="flexLabel" v-if="isShowMoreTime == true">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox
            >
            <el-checkbox-group
              v-model="checkedDays"
              @change="handleCheckedDaysChange"
            >
              <el-checkbox
                v-for="(item, index) in days"
                :label="item.value"
                :key="index"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动时间" v-if="isShowMoreTime == true">
            <div v-for="(item,i) in activeTimeList" :key="i">
              <el-time-picker
                style="width: 128px"
                v-model="item.startTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <span style="color: #333; margin: 0 8px">至</span>
              <el-time-picker
                style="width: 128px"
                v-model="item.endTime"
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
              >
              </el-time-picker>
              <el-button
                style="aspect-ratio: 1/1"
                icon="el-icon-minus"
                circle
                @click="reduceActiveDate(i)"
              ></el-button>
            </div>
            <span class="f6" @click="addUseDate">添加一个时间段</span>
          </el-form-item>

          <h3 class="textTitle">活动规则</h3>
          <el-form-item label="折扣规则">
            <el-radio-group v-model="addForm.discountRule">
              <el-radio :label="1">折扣</el-radio>
              <el-radio :label="2">减免金额</el-radio>
              <el-radio :label="3">指定销售价格</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item label="优惠方式">
            <el-radio-group v-model="addForm.discountMethod">
              <el-radio :label="1">仅购买相同菜品</el-radio>
              <el-radio :label="2">购买不同菜品</el-radio>
            </el-radio-group>
            <div class="tips" v-if="addForm.discountRule==1 && addForm.discountMethod==1">
                例如：相同菜品第2份5折，每购买2份相同活动菜品，其中一份菜品享受5折
            </div>
            <div class="tips" v-if="addForm.discountRule==2 && addForm.discountMethod==1">例如：购买相同活动菜品n份，其中一份减xx元</div>
           <div class="tips" v-if="addForm.discountRule==3 && addForm.discountMethod==1">例如：购买相同活动菜品n份，其中一份价格为xx元</div>
           <div class="tips" v-if="addForm.discountRule==1 && addForm.discountMethod==2">例如：菜品第3份8折，每购买3份任意活动菜品，其中一份菜品享受8折</div>
          <div class="tips" v-if="addForm.discountRule==2 && addForm.discountMethod==2">例如：购买任意n份活动菜品，其中一份减xx元</div>
          <div class="tips" v-if="addForm.discountRule==3 && addForm.discountMethod==2">例如：购买任意n份活动菜品，其中一份价格为xx元</div>
           </el-form-item>
           <div style="display:flex;">
              <el-form-item label="每购买" required >
                   <el-input style="width: 180px" v-model="addForm.buyNum">
                       <template slot="append">份</template>
                   </el-input> 
              </el-form-item>
        <el-form-item v-if="addForm.discountRule==1" label="其中一份享受优惠" required label-width="140px" style="margin-left:40px;">
       <el-input style="width: 180px" placeholder="8折请输入80" v-model="addForm.buyRate">
          <template slot="append">%</template>
         </el-input> 
           </el-form-item>
            <el-form-item v-if="addForm.discountRule==2" label="其中一份减" required label-width="140px" style="margin-left:40px;">
       <el-input style="width: 180px" placeholder="请输入减免金额" v-model="addForm.reductAmount">
         <template slot="append">元</template>
                   </el-input> 
              </el-form-item>
                <el-form-item v-if="addForm.discountRule==3" label="其中一份指定价格" required label-width="140px" style="margin-left:40px;">
                <el-input style="width: 180px" placeholder="请输入指定价格" v-model="addForm.appointAmount">
                  <template slot="append">元</template>
                   </el-input> 
              </el-form-item>
              </div>
            <el-form-item label="算价规则" v-if="addForm.discountMethod==2">
                <el-checkbox v-model="calcRule">从最低价菜品享受优惠</el-checkbox>
            </el-form-item>
             <el-form-item label="选择优惠菜品" required>
              <div class="select" @click="showDishesDialog">选择菜品（已选{{selectDishesList.length}}个）</div>
              <div class="dishesBox" v-if="selectDishesList.length>0">
                  <el-tag type="info" class="mr5" @close='delSelect(index)' closable v-for="(item,index) in selectDishesList" :key="index">{{item.productName}}</el-tag>
              </div>
          </el-form-item>
    
           
          <el-form-item label="活动说明" style="margin-top: 16px">
            <el-input
              class="myTextArea"
              type="textarea"
              placeholder="请输入内容"
              v-model="addForm.description"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="save">
      <el-button class="cancel" @click="() => {this.$router.go(-1)}">取消</el-button>
      <el-button class="sumbit" :loading="isSubmit" @click="submitActivite">保存</el-button>
    </div>

  <DishesDialog :dishesDialogVisible="isShowDishes" :defoultSelect='selectDishesList' :selectType='selectType' @handleDishesClose='dishesDialogClose'></DishesDialog>
  
  </div>
</template>

<script>
import moment from 'moment';
import DishesDialog from './components/DishesDialog.vue';
export default {
components:{
    DishesDialog
  },
  data() {
    return {
      selectType:'',
      isShowDishes:false,
      catogaryDialog:false,
      isShowMoreTime: false,
      moreTimeText: "展开",
      dataMore: false,
      textarea: "",
      radio: 0,
      value: "",
      dateRange: [],
      checkAll: true,
      isIndeterminate: false,
      days: [
        {
           label:'星期一',
           value:'1',
        },
        {
           label:'星期二',
           value:'2',
        },
        {
           label:'星期三',
           value:'3',
        },
        {
           label:'星期四',
           value:'4',
        },
        {
           label:'星期五',
           value:'5',
        },
        {
           label:'星期六',
           value:'6',
        },
        {
           label:'星期日',
           value:'7',
        },
      ],
      checkedList: ["1"],
      hdrq: 1,
      checkedDays: ['1','2','3','4','5','6','7'],
      unuseDateList:[],
      pickerOptions:{
        //限制日期
        disabledDate(time){
           return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      activeTimeList:[
        { 
          merchantCode:localStorage.getItem('merchantCode'),
          merchantName:localStorage.getItem('merchantName'),  
          startTime:'00:00',
          endTime:'23:59'
        }],
      discountRule:0,
      buyDishes:1,
      calcRule:false,
      selectDishesList:[],
      addForm:{
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName'),
        planName:'',//活动名称
        planType:5,//第n份优惠5
        planChannel:'1',//活动渠道 收银机
        showName:'',//展示名称
        planDateType:1,//活动日期
        discountRule:1,//折扣规则
        discountMethod:1,//优惠方式
        buyRate:'',//其中一份优惠
        reductAmount:'',//其中一份减免
        appointAmount:'',//其中一份指定价格
      },
      isSubmit:false,
      planCode:'',
      currPage:1,
      pageSize:10,
      activeDetail:{},
      allDishesList:[],
    };
  },
  created(){
     this.planCode = this.$route.query.planCode
     this.currPage = this.$route.query.currPage
     this.pageSize = this.$route.query.pageSize
       if(this.dateRange==null || this.dateRange.length==0){
        let startDt=moment().format("YYYY-MM-DD")
        let endDt=moment().add(30, 'days').format("YYYY-MM-DD")
        console.log(startDt,endDt)
      this.dateRange[0]=new Date(startDt).getTime()
      this.dateRange[1]=new Date(endDt).getTime()
     }
     if (this.planCode) {
        this.getActiveDetail()
     }
  },
  methods: {
    test(){
      console.log(this.dateRange)
    },
    //查询详情
   async getActiveDetail(){
       let data = {}
       data.planCode = this.planCode
       data.merchantCode = localStorage.getItem('merchantCode')
      await this.$http.post('/merchantDiscountPlan/queryOne',data).then(res => {
         if(res.data.code == 200) {
             this.addForm = res.data.data
             this.checkedDays = res.data.data.planWeek.split(',')
             if (this.checkedDays.length<7) {
                this.checkAll = false
             }
             res.data.data.unUseDateList.forEach( e => {
                 e.time = [e.startDate,e.endDate]
             })
             this.unuseDateList = res.data.data.unUseDateList
             this.activeTimeList = res.data.data.planTimeList
             this.calcRule = res.data.data.mIniPriceProduct
             this.dateRange = [this.addForm.startDate,this.addForm.endDate]
             this.selectDishesList = res.data.data.productList
             console.log(res,'ressss')
          }
       })
    },
    //提交优惠活动
  async submitActivite(){
       this.isSubmit = true
       this.getDIYDate()
       const data = this.addForm
       data.unUseDateList = this.unuseDateList
       data.planWeek = this.checkedDays.join(',')
       data.planTimeList = this.activeTimeList
       data.isMIniPriceProduct = this.calcRule == true ? '1':'0'
       let list = []
       this.selectDishesList.forEach(e => {
          list.push({
            merchantCode:localStorage.getItem('merchantCode'),
            merchantName:localStorage.getItem('merchantName'),
            productCode:e.productCode,
            productName:e.productName,
            type:1,
            normalPrice:e.normalPrice,
            unit:e.unit,
            categoryCode:e.categoryCode,
            categoryName:e.categoryName
          })
       })
       data.productList = list
       if (this.planCode) {
         data.planCode = this.planCode
       }
     let res=await  this.$http.post('/merchantDiscountPlan/saveDiscountPlan',data)
         this.isSubmit = false
         if(res.data.code == 200) {
              this.$notify.success({
                title: "提示",
                message: "保存成功",
                showClose: true,
            });
            setTimeout( () => {
                this.$router.push('/merchantDiscountPlan')
            },1000)
          } else {
            this.$message.error(res.data.message)
          }

    },
    //获取不可用时间段
    getUnableDate(index){
      let time = this.unuseDateList[index].time
        if (time) {
            this.unuseDateList[index].startDate = time[0]
            this.unuseDateList[index].endDate = time[1]
        } else {
            this.unuseDateList[index].startDate = ''
            this.unuseDateList[index].endDate = ''
        }

    },
    //获取自定义日期
    getDIYDate(){
       if (this.dateRange) {
          this.addForm.startDate = this.dateRange[0]
          this.addForm.endDate = this.dateRange[1]
       } else {
          this.addForm.startDate = ''
          this.addForm.endDate = ''
       }
    },
    //获取活动渠道
    getActiveRules(e){
      console.log(e);
    },
    //打开菜品弹框
    showDishesDialog(){
       this.isShowDishes = true
    },
    delSelect(index){
      let list = JSON.parse(JSON.stringify(this.selectDishesList))
      this.selectDishesList = null
      list.splice(index,1)
      this.selectDishesList = list
      console.log('删除',this.selectDishesList);
    },
    // 菜品弹框返回
    dishesDialogClose(e,val){
        console.log(e,val,'确定');
       this.isShowDishes = false
       this.selectDishesList = JSON.parse(JSON.stringify(val))
    },
    //
    //添加活动时间
    addUseDate(){
      this.activeTimeList.push( { 
          merchantCode:localStorage.getItem('merchantCode'),
          merchantName:localStorage.getItem('merchantName'),  
          startTime:'00:00',
          endTime:'23:59',
        })
    },
    //减少活动时间
    reduceActiveDate(index){
        if (this.activeTimeList.length == 1) {
            this.$message.error('不可删除')
            return
        }
       this.activeTimeList.splice(index,1)
    },
    //添加不可用时间段
    addUnuseDate(){
      this.unuseDateList.push({
        merchantCode:localStorage.getItem('merchantCode'),
        merchantName:localStorage.getItem('merchantName'),
        startDate:'',
        endDate:'',
        time:[],
      })
    },
    //减少不可用时段
    reduceUnuseDate(index){
      this.unuseDateList.splice(index,1)
    },
    //时间设置更多
    showMoreTime() {
      this.isShowMoreTime = !this.isShowMoreTime;
      if (this.isShowMoreTime == true) {
        this.moreTimeText = "收起";
      } else {
        this.moreTimeText = "展开";
      }
    },
    handleCheckAllChange(val) {
        // console.log('val',val);
      //this.checkedDays = val ? this.days : [];
      if (val) {
        this.checkedDays = ['1','2','3','4','5','6','7']
      } else {
        this.checkedDays = []
      }
      this.isIndeterminate = false;
    },
    handleCheckedDaysChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.days.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.days.length;
    },
    go(val) {
      let box = document.querySelectorAll(".scroll")[0];
      box.scrollTop = val;
    },
  },
};
</script>

<style lang="less" scoped>
.allBox {
  height: 100%;
  background: #fff;
  .title {
    padding: 6px 20px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
    i,
    span {
      font-size: 20px;
      font-weight: 500;
    }
  }
  .href {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid rgb(229, 229, 229);
    overflow: hidden;
    padding-left: 4px;
    // padding: 6px 20px;
    .item {
      padding: 7px 16px;
      overflow: hidden;
      color: rgb(51, 51, 51);
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      span {
        cursor: pointer;
        transition: all 0.3s ease 0s;
      }
      span:hover {
        color: rgb(255, 96, 0);
      }
    }
  }
  .mainBox {
    padding: 24px;
    .card {
      border: 1px solid rgb(232, 232, 232);
      border-radius: 2px;
      transition: all 0.3s ease 0s;
      .cardBody {
        padding: 24px;
        display: flex;
        .left {
          margin-right: 16px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .right {
          .top {
            margin-bottom: 8px;
            overflow: hidden;
            color: rgb(51, 51, 51);
            font-weight: 500;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .bottom {
            color: rgb(102, 102, 102);
            font-size: 14px;
          }
        }
      }
    }
  }
}
.textTitle {
  position: relative;
  right: 24px;
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;
  width: max-content;
  border-left: none;
  margin-bottom: 16px;
  margin-top: 16px;
  background-image: linear-gradient(
    270deg,
    rgba(255, 189, 0, 0),
    rgba(255, 202, 0, 0.14) 49%,
    rgba(255, 208, 0, 0.3)
  );
  color: rgb(34, 34, 34);
  font-weight: 500;
  border: none;
}
.diaBox {
  margin-top: 8px;
  background: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 16px;
  margin-left: 112px;
  .inner {
    display: flex;
    .left {
      display: flex;
      width: 120px;
      justify-content: flex-end;
      color: #333;
      font-size: 14px;
    }
    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      color: #333;
      font-size: 14px;
      .top {
        .select {
          color: #ff6000;
          cursor: pointer;
        }
        .c9 {
          color: #999;
        }
      }
      .bottom {
        max-height: 84px;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        // border: 1px solid rgb(229, 229, 229);
        padding: 5px;
        padding-bottom: 4px;
        line-height: 32px;
        background-color: #fff;
        .item {
          box-sizing: border-box;
          color: rgb(51, 51, 51);
          height: auto;
          margin: 6px 8px 0px 0px;
          padding: 0px 7px;
          font-size: 12px;
          line-height: 20px;
          white-space: nowrap;
          background: rgb(250, 250, 250);
          border: 1px solid rgb(229, 229, 229);
          border-radius: 4px;
          cursor: default;
          user-select: none;
        }
      }
    }
  }
}
/deep/ .el-form-item__label::after,
.pcfn::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}
/deep/ .labelMore {
  color: rgb(102, 102, 102);
  font-size: 14px;
}
/deep/ .scroll {
  height: calc(100vh - 220px);
  overflow: auto;
  scroll-behavior: smooth;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ffbd00;
}
/deep/ .el-checkbox__input.is-checked {
  .el-checkbox__inner {
    background-color: #ffbd00;
    border-color: #ffbd00;
  }
}
/deep/ .el-checkbox__inner:hover {
  border-color: #ffbd00;
}
/deep/ .el-checkbox__inner:active {
  border-color: #ffbd00;
}
/deep/ .el-checkbox__label {
  color: #606266 !important;
}
/deep/ .el-radio__label {
  color: #606266 !important;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #ffbd00;
  border-color: #ffbd00;
}
/deep/ .f6 {
  color: #ff6000;
  font-size: 14px;
  cursor: pointer;
}
/deep/ .flexLabel > div {
  display: flex;
}
/deep/ .el-checkbox__input.is-indeterminate {
  .el-checkbox__inner {
    background-color: #fff;
    border-color: #dcdfe6;
  }
}
/deep/ .el-checkbox:last-of-type,
.el-checkbox {
  margin-right: 10px;
}
/deep/ .suffixIcon {
  padding: 0 11px;
  // background-color: rgb(250,250,250);
  color: #333;
  // border-radius: 4px;
  // border: 1px solid rgb(229,229,229);
}
/deep/ label.el-radio {
  margin-right: 16px;
}
::-webkit-scrollbar-thumb {
  background: #ccc;
}
/deep/ .myTextArea {
  textarea {
    height: 77px;
    color: #333;
    font-size: 14px;
  }
  textarea:focus {
    border-color: #ffbd00;
  }
}
/deep/ .el-button.is-circle {
  border-radius: 50%;
  margin-left: 8px;
  background-color: #ffbd00;
  height: 24px;
  width: 24px;
  i {
    font-weight: 700;
    transform: translate(-2px, -1px);
    color: #000;
  }
  i:hover {
    color: #000;
  }
}
.save {
  padding: 10px 32px;
  text-align: right;
  background: transparent;
  border-top: 1px solid rgb(232, 232, 232);
  border-radius: 0px 0px 4px 4px;
  display: flex;
  justify-content: right;
  font-weight: 400;
  .sumbit {
    background-color: #ffbd00;
    color: #000;
  }
  .sumbit:hover {
    opacity: 0.8;
  }
  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
}

/deep/.el-main {
  height: 100vh;
}
.hasSelectBox{
   display: flex;
   justify-content: space-between;
   margin-top: 10px;
}
.pd24{
    padding: 24px;
}
.nameItem{
      margin: 0px 3px 3px 0px;
}
.select {
    color: #ff6000;
    cursor: pointer;
 }
 .mr5{
    margin-right: 5px;
    margin-bottom: 5px;
 }
   .sumbit {
    background-color: #ffbd00;
    border: none;
    color: #000;
  }
  .sumbit:hover {
    opacity: 0.8;
  }
  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
  .tips{
    margin-top: 20px;
    margin-bottom: 18px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 16px;
    white-space: nowrap;
  }
  .dishesBox{
    padding: 5px;
    border: 1px solid rgb(229, 229, 229);
  }
</style>